const ResistEvent = function( battleState, actor ) {
	this.eventHandle = 'resist';
	this.actorId = actor.uid;
	
	this.execute = () => {
		battleState.onBattleEvent( this );	
	};
};
module.exports = ResistEvent
